import type { GroupId, WorkspaceId, UserId } from 'balus-common';
import { trpcClient } from '../trpcClient';

type ResourceType = 'group-icons' | 'workspace-icons' | 'user-icons';
type ResourceId = GroupId | WorkspaceId | UserId;

export class PublicIconUploader {
  private static async uploadIconViaTrpc(resourceType: ResourceType, resourceId: ResourceId, data: Blob) {
    const formData = new FormData();
    formData.append('resourceType', resourceType);
    formData.append('resourceId', resourceId);
    formData.append('file', data);
    const result = await trpcClient.user.uploadIcon.mutate(formData);
    return result.downloadUrl;
  }

  static async uploadGroupIcon(groupId: GroupId, data: Blob) {
    return this.uploadIconViaTrpc('group-icons', groupId, data);
  }

  static async uploadWorkspaceIcon(workspaceId: WorkspaceId, data: Blob) {
    return this.uploadIconViaTrpc('workspace-icons', workspaceId, data);
  }

  static async uploadUserIcon(userId: UserId, data: Blob) {
    return this.uploadIconViaTrpc('user-icons', userId, data);
  }
}
